import React from "react";
import BenifitsImage from "../../assets/images/career/young-environment.png";
import BenifitsSalaryImage from "../../assets/images/career/competitive-salary.png";
import CareerSupportiveImage from "../../assets/images/career/supportive-tech.png";
import CareerFunImage from "../../assets/images/career/fun-fridays.png";
import CareerPantryImage from "../../assets/images/career/feel-good-pantry.png";
import CareerMedicalImage from "../../assets/images/career/medical-insurance.png";

const Benifits = () => {
  const customGridTemplateColumns = "repeat(3, 1fr)";

  return (
    <>
      <section className="_border-top">
        <div className="max-container">
          <div className="padd-90">
            <h2 className="roboto-bold mb40 heading29px text-center">
              Benefits
            </h2>

            <div
              className="grid-auto-fit"
              style={{ "--grid-columns": customGridTemplateColumns }}
            >
              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={BenifitsImage}
                  height="50"
                  width="50"
                  alt="Young Environment"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Young Environment
                </h3>
                <p className="heading16px roboto-regular">
                  Support our Clients' Business Processes
                </p>
              </div>

              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={BenifitsSalaryImage}
                  height="50"
                  width="50"
                  alt="Competitive Salary"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Competitive Salary
                </h3>
                <p className="heading16px roboto-regular">
                  Saving their Time and Cost, adding value to their bottom-line
                </p>
              </div>

              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={CareerSupportiveImage}
                  height="50"
                  width="50"
                  alt="Supportive Tech"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Supportive Tech
                </h3>
                <p className="heading16px roboto-regular">
                  Helping them in Identifying, Targeting & Leveraging New
                  Opportunities
                </p>
              </div>

              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={CareerFunImage}
                  height="50"
                  width="50"
                  alt="Fun Fridays"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Fun Fridays
                </h3>
                <p className="heading16px roboto-regular">
                  Back their Presales, Business Development & Post Sales CRM
                </p>
              </div>

              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={CareerPantryImage}
                  height="50"
                  width="50"
                  alt="Fun Fridays"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Feel Good Pantry
                </h3>
                <p className="heading16px roboto-regular">
                  Power their Research and Knowledge Management Engine
                </p>
              </div>

              <div className="common-white-box homeServicesBox common-shadow">
                <img
                  src={CareerMedicalImage}
                  height="50"
                  width="50"
                  alt="Medical Insurance"
                  className="img-fluid radius-career-icon-image"
                />
                <h3 className="heading20px roboto-bold mb10 mt20">
                  Medical Insurance
                </h3>
                <p className="heading16px roboto-regular">
                  Our state-of- the-art server control, dedicated firewall setup
                  enables you to run your business smoothly
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Benifits;
